import {
    groupRecordsInQuickAccess,
    quickAccessOpened,
    quickAccessPinned,
} from "containers/Projects/components/ProjectTree/utils";

import { bootstrapUserNameKey } from "utils/RouterManager/constants";

export const getWorkspaceData = (state) => state.workspaces?.[state.auth?.user?.workspace_id];

export const getWorkspaceRecords = (state) => state.nonProjectRecords;

// Single-slot memo (there is one Redux store): recompute the derived object
// only when the underlying `nonProjectRecords` / workspace references actually
// change. Without this the selector spread-rebuilds a brand-new object on every
// `useSelector(getWorkspaceWithQuickAccess)` call, so ProjectTree re-renders on
// every unrelated live-subscription push (the workspace-list fan-whirr).
let lastRecords;
let lastWorkspace;
let lastResult;

export const getWorkspaceWithQuickAccess = (state) => {
    const workspaceRecords = getWorkspaceRecords(state);
    const workspace = getWorkspaceData(state);

    if (
        lastResult !== undefined &&
        workspaceRecords === lastRecords &&
        workspace === lastWorkspace
    ) {
        return lastResult;
    }

    const openedQuickAccessData = groupRecordsInQuickAccess(workspaceRecords, "opened");
    const pinnedQuickAccessData = groupRecordsInQuickAccess(workspaceRecords, "pinned");

    lastRecords = workspaceRecords;
    lastWorkspace = workspace;
    lastResult = {
        ...workspace,
        [quickAccessOpened]: openedQuickAccessData.opened,
        [quickAccessPinned]: pinnedQuickAccessData.pinned,
    };

    return lastResult;
};

export const bootstrapUserNameSelector = (state) => state?.dataStore?.[bootstrapUserNameKey];
